import React, { useRef } from "react";
import Files from "react-files";
import { useApolloClient } from "@apollo/client";
import { injectIntl, IntlShape } from "react-intl";
import { displaySnackBar } from "../../utils/snackBarUtils";
import { MESSAGE_TYPE } from "../../utils/constant";
import { CustomButton, CustomButtonProps } from "./CustomButton";

interface FileUploadSimplePropsInterface {
  label: string;
  intl: IntlShape;
  handleChange(file: File): void;
  children?: any;
  disabled?: boolean;
}

const CustomFileUploadSimple = (
  props: FileUploadSimplePropsInterface & CustomButtonProps,
) => {
  const { handleChange, label, intl, children, disabled } = props;
  const filesRef = useRef<any>();
  const client = useApolloClient();

  const onFilesChange = (files: File[]): void => {
    if (filesRef && filesRef.current) {
      // Réinitialise la liste interne pour permettre de télécharger à nouveau
      filesRef.current.state.files = [];
    }
    handleChange(files[0]);
  };

  const onFilesError = (error: any) => {
    const { code } = error;
    let message: string = "";
    switch (code) {
      case 1:
        message = intl.formatMessage({ id: "error.uploadFileInvalid" });
        break;
      case 2:
        message = intl.formatMessage({ id: "error.uploadFileTooLarge" });
        break;
      case 3:
        message = intl.formatMessage({ id: "error.uploadFileTooSmall" });
        break;
      case 4:
        message = intl.formatMessage({ id: "error.uploadOnlyOneFile" });
        break;
      default:
        message = intl.formatMessage({ id: "error.uploadFileUnknown" });
    }
    displaySnackBar(client, {
      type: MESSAGE_TYPE.ERROR,
      message,
      isOpen: true,
    });
  };

  return (
    <Files
      ref={filesRef}
      onChange={onFilesChange}
      onError={onFilesError}
      accepts={["image/*"]}
      maxFiles={1}
      maxFileSize={10000000}
      minFileSize={0}
      clickable={true}
    >
      <CustomButton {...props}>{children}</CustomButton>
    </Files>
  );
};

export default injectIntl(CustomFileUploadSimple);
